import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import View from './changePassword';
import { changePassword } from "../../APIs";
import { getUrlVars, errorHandler } from "../../utils";
import { withMultiLanguagesConsumer } from "../../contexts/messages";

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: getUrlVars()["username"] || "",
            password: getUrlVars()["temp"] || "",
            newPassword: "",
            confirmPassword: "",
            loading: false,
            checkSession: false,
        };

        this.fields = [
            {
                title: "New Password",
                helperMsg: "",
                field: "newPassword",
            },
            {
                title: "Comfirm Password",
                helperMsg: "",
                field: "confirmPassword",
            },
        ];
        this.fromDomain = this.props.match.params.domain;
        this.fromMerchantId = this.props.match.params.merchantId;
        this.changePasswordHandler = this.changePasswordHandler.bind(this);
        this.setInputField = this.setInputField.bind(this);
        this.loadingToggler = this.loadingToggler.bind(this);
    }

    setInputField = field => event => {
        this.setState({ [field]: event.target.value });
    };

    changePasswordHandler() {
        const { PWD_NOT_MATCH, PWD_RESET_SUCCESS } = this.props.messagePool;
        if (this.state.newPassword != this.state.confirmPassword) {
            alert(PWD_NOT_MATCH);
            return;
        }
        this.loadingToggler();
        changePassword(decodeURIComponent(this.state.userName), this.state.password, this.state.newPassword)
        .then(res => {
            console.log(res);
            alert(PWD_RESET_SUCCESS);
            const redirect_uri = getUrlVars()["redirect_uri"]
            this.props.history.push(`/login?username=${this.state.userName}&redirect_uri=${redirect_uri}`)
        })
        .catch(err => {
            errorHandler(err);
            this.loadingToggler();
        })
    }

    loadingToggler() {
        this.setState({
            loading: !this.state.loading
        })
    }

    render() {
        console.log(getUrlVars()["username"]);
        return (
            <View   fieldsInfo={this.fields}
                    changePasswordHandler={this.changePasswordHandler}
                    setInputField={this.setInputField}
                    loadingToggler={this.loadingToggler}
                    state={this.state}
                    {...this.state} />
        )
    }
}

function mapStateToProps(state){
    return{

    }
}

export default withMultiLanguagesConsumer(withRouter(connect(mapStateToProps , {

})(ChangePassword)));